import React from "react";
import {NavLink} from "react-router-dom";
import logo from "../Images/logo.png";
import "../CSS/Menu.css";

const Menu=()=>
{
    return(
        <>
        <header>
            <div className="container container-flex">
                <div className="logoContainer">
                    <img src={logo} alt="logo" className="logo"></img>
                </div>
            <nav>
                <div className="list">
                    <NavLink exact={true} to="/" className="listItem" activeClassName="activeItem">Home</NavLink>
                    <a href="https://dribbble.com/Vishnu_S" target="_self" className="listItem" activeClassName="activeItem">Case Study</a>
                    <NavLink to="/experience" className="listItem" activeClassName="activeItem">Experience</NavLink>
                    <NavLink to="/contact" className="listItem" activeClassName="active">Contact Me</NavLink>
                </div>
            </nav>
            </div>
        </header>
        </>
    )
}

export default Menu;